import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import useStyles from 'components/ui/Button/style';

const ButtonCustom = (props) => {
  const classes = useStyles();

  return (
    <Button {...props} className={classes.button}>
      {props.children}
    </Button>
  );
};

ButtonCustom.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  color: PropTypes.string.isRequired,
};

export default ButtonCustom;
